<template>
  <div class="relative overflow-hidden">
    <form id="mauticform_marsroadmap202108" autocomplete="false" role="form" method="post"
          action="https://ma.myarstudio.cloud/form/submit?formId=11" data-mautic-form="marsroadmap202108" enctype="multipart/form-data">
      <input id="mauticform_marsroadmap202108_id" type="hidden" name="mauticform[formId]" value="11">
      <input id="mauticform_marsroadmap202108_return" type="hidden" name="mauticform[return]" value="">
      <input id="mauticform_marsroadmap202108_name" type="hidden" name="mauticform[formName]" value="marsroadmap202108">
      <div id="mauticform_marsroadmap202108_error" class="mauticform-error hidden" />
      <div id="mauticform_marsroadmap202108_message" class="mauticform-message hidden" />

      <!-- <block2-cols-roadmap id="productTag" carousel>
        <div class="img-carousel w-full">
          <img loading="lazy" class="w-full" src="~/assets/img/pricing/ProductTag_1.webp">
          <img loading="lazy" class="w-full img-top" src="~/assets/img/pricing/ProductTag_2.webp">
        </div>
      </block2-cols-roadmap> -->

      <block2-cols-roadmap id="MaterialsLibrary" reverse>
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/MaterialsLibrary-Roadmap.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="ProductConfigurator">
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/Configurator-Roadmap.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="MultiProductPlacement" reverse>
        <video src="~/assets/img/pricing/Multi-product-placement.mp4" class="h-full" autoplay loop muted playsinline font-small />
      </block2-cols-roadmap>

      <block2-cols-roadmap id="ARcart">
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/Cart-Roadmap.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="ARhotspots" reverse>
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/Hotspots-Roadmap.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="STLImporter">
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/CAD-viewer@2x.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="VRMode" reverse>
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/VR-Showroom@2x.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="API">
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/api-access.webp">
      </block2-cols-roadmap>

      <block2-cols-roadmap id="VirtualTryOnFace" reverse>
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/VTO-Volto@2x.webp">
      </block2-cols-roadmap>


      <block2-cols-roadmap id="VirtualTryOnWrist">
        <img loading="lazy" class="w-full h-full" src="~/assets/img/pricing/VTO-mano-polso@2x.webp">
      </block2-cols-roadmap>
    </form>
    <div
      class="w-full bg-darkgray h-full bg-right bg-cover laptop:mt-150px py-12"
    >
      <div class="container mx-auto h-full w-full">
        <div class="flex flex-row h-full flex-wrap">
          <div class="flex flex-col justify-around w-full laptop:w-4/12 laptop:ml-24 p-5 mt-150px laptop:mt-0">
            <div>
              <h3 class="text-white lg:text-55xl md:text-45xl" v-html="$t('roadmap.feature-suggestion')" />
            </div>
          </div>
          <div v-if="clickupFormsEnabled" class="w-full min-h-screen laptop:min-h-0 laptop:w-7/12 flex laptop:p-5 ">
            <iframe ref="clickupIframe"
                    class="clickup-embed clickup-dynamic-height"
                    src="https://forms.clickup.com/f/2hq1h-1421/OIU8SHT4AHJDBSWEMN"
                    width="100%" height="fit-content" style="background: transparent; border: 0px solid #ccc;" />
          </div>
          <div v-else class="m-5 mx-10 p-5 text-white border-2 border-dashed w-full">
            <p>Form disabled because of your cookie preferences.</p>
            <p>To enable it please review your cookie preferences:</p>
            <a class="block text-sm mt-4 hover:text-highlight tracking-widest uppercase cursor-pointer" @click="clickIubenda"> -> Cookie preferences</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useIubenda, useIubendaStore } from 'mars-iubenda-vite';
import { ref, onMounted, watch } from 'vue'

declare global {
  interface Window {
    MauticSDK: any
    MauticDomain: string
    MauticLang: object
  }
}

const {clickupFormsEnabled} = useIubenda()

// Watcher
watch(clickupFormsEnabled, (current) => {
  console.log("clickupFormsEnabled watch", current)
  installClickupScript(current)
})
console.log("clickupFormsEnabled setup", clickupFormsEnabled.value)
function installClickupScript(enable: boolean) {
  if (enable) {
    const head = document.getElementsByTagName('head')[0]
    const clickup = document.createElement('script')
    clickup.setAttribute('data-name', 'clickup-embed')
    clickup.type = 'text/javascript'
    clickup.src = 'https://app-cdn.clickup.com/assets/js/forms-embed/v1.js'
    head.appendChild(clickup)
  }  
}

// Methods
const clickIubenda = () => {
  (document.querySelector('a.iubenda-cs-preferences-link') as HTMLElement)?.click()
}

// Lifecycle hook
onMounted(() => {
  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://ma.myarstudio.cloud/media/js/mautic-form.js'
  script.onload = function () {
    window.MauticSDK.onLoad()
  }
  head.appendChild(script)
  window.MauticDomain = 'https://ma.myarstudio.cloud'
  window.MauticLang = {
    submittingMessage: 'Please wait...',
  }
  const clickup = document.createElement('script')
  clickup.type = 'text/javascript'
  clickup.src = 'https://app-cdn.clickup.com/assets/js/forms-embed/v1.js'
  head.appendChild(clickup)
})
</script>

<style scoped>
@keyframes cf3FadeInOut {
  0% {
    opacity: 1;
  }
  45% {
    opacity: 1;
  }
  55% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}


div.img-carousel {
  position: relative;
}

div.img-carousel img {
  position: absolute;
  left: 0;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

div.img-carousel img.img-top {
  animation-name: cf3FadeInOut;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 5s;
  animation-direction: alternate;
}

p {
  @apply laptop:text-slg md:text-base leading-7
}

h3 {
  @apply text-2xl font-bold
}
</style>
